import { Sponsor } from '../../shared/models/sponsor.model';
import { ItemLoyaltyState } from './item-loyalty-state';
import { LoyaltyLimitType } from './loyalty-limit-type';

export class LottoItem {
  LottoId: number;
  Title: string;
  Description: string;
  TermsAndConditions: string;
  StartDate: Date | string;
  EndDate: Date | string;
  LottoTypeId: number;
  PurchasePrice: number;
  Category: number;
  /** Stock for the lotto. 0 is unlimited stock */
  MaxTotalTicketLimit: number;
  ShowNumberOfTickets: boolean;
  ImageName: string;
  ThumbNailImageName: string;
  Active: boolean;
  AutoEnrollment: number;
  CompleteActionId: number;
  ShowTermsAndConditions: boolean;
  TermsAndConditionsType: number;
  LottoMode: number;
  AllowComingSoon: number;
  Favourite: number;
  LimitCount: number;
  RequestTime: Date | string;
  Gamenumber: number;
  SectionId: number;
  Ordinal: number;
  SendEmailOnEntry: boolean;
  Deleted: number;
  EmailCategoryId: number;
  /** Purchased by current MemberId */
  NumberOfTicketsPurchased: number;
  /** Purchased by current Account */
  NumberOfTicketsPurchasedByAccount: number;
  /** Purchased by all users */
  TotalNumberOfTicketsPurchased: number;
  /** MaxTotalTicketLimit - TotalNumberOfTicketsPurchased */
  AvailableCount: number;
  IsAdminUser: boolean;
  ItemState: ItemLoyaltyState;
  LimitType: LoyaltyLimitType;
  UnlimitedLimit: boolean;
  DisableManualEntry: boolean;
  ShowOnDisableManualEntry: boolean;
  Sponsor: Sponsor;
  Locked?: boolean;
  static [Symbol.hasInstance](instance: any): instance is LottoItem {
    return 'LottoId' in instance && typeof instance.LottoId === 'number';
  }
}

export const LOTTO_TEXT_COLOR = {
  BLACK: 'text-rewards-black',
  RED: 'text-rewards-danger',
  GREEN: 'text-rewards-success',
  NEW: 'text-rewards-new',
};

export const LOTTO_STATE = {
  LIMITED: 'lottos.limited.stock',
  FEATURED: 'lottos.featured.stock',
  REMAINING: 'lottos.panel.remaining.stock',
  NEW: 'lottos.new.stock',
  SOLD_OUT: 'lottos.sold.out',
  NOT_ENOUGH_POINT: 'lottos.not.enough',
  COMING_SOON: 'lottos.coming.soon',
  LIMIT_REACHED: 'lottos.limit.reached',
  VIEW: 'lottos.view',
  LOCKED: 'lottos.locked',
  ENTERED: 'lottos.entered',
};
